import { cn } from '@/lib/utils'

export interface TabItem {
  value: string
  label: string
  count?: number
}

/**
 * Standard in-page tab bar (underline style). Use this for every tabbed view
 * across the app so they all look and behave the same.
 *
 * <Tabs items={[{value:'a',label:'A',count:3},{value:'b',label:'B'}]} value={tab} onChange={setTab} />
 */
export function Tabs({
  items,
  value,
  onChange,
  className,
}: {
  items: TabItem[]
  value: string
  onChange: (value: string) => void
  className?: string
}) {
  return (
    <div className={cn('mb-6 flex gap-6 overflow-x-auto border-b border-border', className)}>
      {items.map((t) => {
        const active = t.value === value
        return (
          <button
            key={t.value}
            type="button"
            onClick={() => onChange(t.value)}
            className={cn(
              '-mb-px shrink-0 whitespace-nowrap border-b-2 pb-2 text-sm transition-colors',
              active
                ? 'border-primary font-medium text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            )}
          >
            {t.label}
            {typeof t.count === 'number' && (
              <span className={cn('ml-1.5', active ? 'text-muted-foreground' : 'text-muted-foreground/70')}>
                {t.count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
